import { createSlice } from "@reduxjs/toolkit"

export const inactiveVouchersListSlice = createSlice({
	name: "inactive_vouchers",
	initialState: {
		inActiveVouchers:"",
		errors: [],
	},

	reducers: {
        getInActiveVouchers: (state, action) => {
         
			state.inActiveVouchers = action.payload
		},
		getInActiveVouchersList: (state, action) => {
         
			state.inActiveVouchers = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})
export const {getInActiveVouchers, getInActiveVouchersList, getErrors} = inactiveVouchersListSlice.actions

export default inactiveVouchersListSlice.reducer
